import { EuiFlexGroup,EuiFlexItem,EuiFieldSearch,EuiListGroup, EuiText , EuiLoadingSpinner} from '@elastic/eui';
import React,{ useEffect, useMemo, useState } from 'react';
import { ItemList } from './item';

export const Listado = (props:any) =>{

    const {titulo, data, onClickItem, actions, onRemoveItem, selected, search} = props;
    const [dataListSearch, setDataListSearch] = useState<any>([]);
    const [dataSearch, setDataSearch] = useState('');

    const onChangeSearch = (value:string)=>{
        setDataSearch(value);
    }

    const onSearch =(value:string)=>{
        if(value!== ''){
            let newBusqueda:any = [];
            newBusqueda = data.filter((f: any) => { if(new RegExp(`${value}.*`, "i").test(f["label"]) || new RegExp(`${value}.*`, "i").test(f["login"])){return f.label} });
        
            setDataListSearch((oldArray:any) => [...newBusqueda])
        }else{
            setDataListSearch((oldArray:any) => [])
        }
    }

    useEffect(()=>{
        if(dataSearch===''){
            setDataListSearch((oldArray:any) => [])
        }
    },[dataSearch])

    const getIsEnabled = (item:any) =>{
        const res = selected.findIndex((f:any)=> f.dni === item.dni)
        return res
    }

    const getItemsSearch = useMemo(() =>{
        dataListSearch.sort((a:any,b:any) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))
        return dataListSearch.map((d:any)=> {
            const isEnabled = selected!==undefined ? (getIsEnabled(d) !== -1) : false
            return <ItemList data={d} active={isEnabled} onClickItem={onClickItem} actions={actions} onRemoveItem={onRemoveItem}/>
        })
        
    },[dataSearch ,dataListSearch, selected])

    const getItems = useMemo(() =>{
        data.sort((a:any,b:any) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))
        return data.map((d:any)=> {
            const isEnabled = selected!==undefined ? (getIsEnabled(d) !== -1) : false
            return <ItemList data={d} active={isEnabled} onClickItem={onClickItem} actions={actions} onRemoveItem={onRemoveItem}/>
        })
    },[data,selected])

    const getSearch = useMemo(() => search && <EuiFieldSearch fullWidth placeholder='Buscar Usuario o Login...' compressed onChange={(e)=>onChangeSearch(e.target.value)} onSearch={onSearch}/>,[search])
    
    return (
        <>
        <EuiFlexGroup>
            <EuiFlexItem grow={false}><EuiText style={{fontWeight:'bold'}} size="m" color={titulo.color}>{titulo.titulo}</EuiText></EuiFlexItem>
            <EuiFlexItem style={{minHeight:'32px'}}>{getSearch}</EuiFlexItem>
        </EuiFlexGroup>
        <EuiListGroup style={{height:'100%', minHeight:'450px', overflow:'auto'}} bordered maxWidth={false}>{dataListSearch.length>0 ? getItemsSearch : getItems}</EuiListGroup>
        </>
    )
}